var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMessenger({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9642 8.73086C17.9642 13.7271 14.0497 17.4261 9.00003 17.4261C8.09322 17.4261 7.22298 17.3063 6.40509 17.0815C6.24625 17.0374 6.07736 17.0499 5.92641 17.1163L4.1472 17.9019C3.68178 18.1074 3.15649 17.7764 3.14107 17.268L3.0923 15.6731C3.08621 15.4766 2.998 15.293 2.85135 15.1621C1.10692 13.6023 0.0358887 11.3444 0.0358887 8.73086C0.0358887 3.73461 3.95035 0.0356445 9.00003 0.0356445C14.0497 0.0356445 17.9642 3.73461 17.9642 8.73086Z",
    fill: "#0866FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.434 11.2344L14.555 6.411C14.8687 5.92622 14.2875 5.36184 13.812 5.68993L10.5541 7.93706C10.4444 8.01271 10.2995 8.01487 10.1877 7.94244L7.29583 6.07144C7.05093 5.91295 6.72427 5.98323 6.56615 6.22777L3.44483 11.0512C3.13109 11.536 3.71232 12.1004 4.18778 11.7723L7.44643 9.52479C7.55615 9.44913 7.70101 9.44698 7.81288 9.51941L10.704 11.39C10.9489 11.5485 11.2755 11.4783 11.434 11.2337V11.2344Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMessenger);
export default __webpack_public_path__ + "static/media/logo-messenger.3759ed7c.svg";
export { ForwardRef as ReactComponent };